import { Stepper as MUIStepper, Step, StepButton } from "@mui/material";
import Typography from "components/common/Typography";
import { tokens } from "styles/Tokens";

interface StepperProps {
  setCurrentStep: (index: number) => void;
  flow: string[] | null;
  currentStep: number;
  color: string;
}

const Stepper = (props: StepperProps) => {
  const { setCurrentStep, flow, currentStep, color } = props;

  return (
    <MUIStepper activeStep={currentStep} alternativeLabel sx={{ width: "100%", marginTop: "16px" }}>
      {flow?.map((label: any, index: any) => (
        <Step
          sx={{
            "& .MuiButtonBase-root": {
              margin: "-30px -16px",
              display: "inherit"
            },
            "& .MuiStepLabel-root .Mui-disabled .MuiSvgIcon-root": {
              fill: tokens.Background.General.Primary,
              boxShadow: "0px 0px 4px rgba(19, 41, 138, 0.1), 0px 10px 25px rgba(19, 41, 138, 0.1)",
              borderRadius: "50%"
            },
            "& .MuiStepLabel-root .Mui-disabled .MuiStepIcon-text": {
              fill: tokens.Text.General.Tertiary
            },
            "& .MuiStepLabel-root .Mui-active": {
              color: tokens.Primary.Primary400
            },
            "& .MuiStepLabel-root .Mui-completed": {
              color: tokens.Border.General.Secondary
            },
            "& .MuiStepConnector-line": {
              border: `2px dashed ${tokens.Border.General.Tertiary}`
            },
            "& .MuiStepLabel-iconContainer .MuiStepIcon-text": {
              fontSize: "20px"
            },
            "& .MuiSvgIcon-root": {
              width: "34px",
              height: "34px"
            }
          }}
        >
          <StepButton onClick={() => setCurrentStep(index)} disableRipple>
            <Typography variant={"label"} color={color}>
              {label}
            </Typography>
          </StepButton>
        </Step>
      ))}
    </MUIStepper>
  );
};

export default Stepper;
